// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__34nEc","additionalInfo":"AgreementModal_additionalInfo__1RfNL"};